<div id="idAsistenteContainer" *ngIf="!loadMantenedor" style="height: 100%; overflow:hidden">
    <app-asistente-en-linea (loadMantenedor)="loadMantenedorComp()"></app-asistente-en-linea>
</div>
<div id="idMantenedorContainer" *ngIf="loadMantenedor">
    <router-outlet></router-outlet>
</div>